exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar .raw-image[data-v-20e5005d],.avatar .wrapper[data-v-20e5005d]{border-radius:50%;overflow:hidden}.avatar.avatar-sm i[data-v-20e5005d]{font-size:40px;line-height:40px}.avatar.avatar-sm .raw-image[data-v-20e5005d],.avatar.avatar-sm .wrapper[data-v-20e5005d]{width:40px;height:40px}.avatar.avatar-lg i[data-v-20e5005d]{font-size:100px;line-height:100px}.avatar.avatar-lg .raw-image[data-v-20e5005d],.avatar.avatar-lg .wrapper[data-v-20e5005d]{width:100px;height:100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20e5005d","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/ProfilePicture.vue
// module id = 1015
// module chunks = 24